import { useApproveDocumentMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import useAlert from "@rf-hooks/useAlert";
import toast from "react-hot-toast";

const useApproveDocument = () => {
  const { alert, successAlert, errorAlert } = useAlert();
  const [approveDocument] = useApproveDocumentMutation();

  const handleApproveDocument = async (documentId: number) => {
    const res = await alert({
      type: "warning",
      color: "orange",
      message: "¿Estas seguro que desea aprobar este documento?",
      declineBtnMessage: "No",
      confirmBtnMessage: "Ok"
    });

    if (res.type.confirm) {
      const request = approveDocument({
        body: {
          validation_document_id: documentId
        }
      })
        .unwrap()
        .then(() => {
          successAlert({
            title: "Documento aprobado exitosamente",
            message: "El documento ha sido aprobado exitosamente"
          });
        })
        .catch(error => {
          errorAlert({
            title: "Error al aprobar el documento",
            message: "Hubo un error al aprobar el documento"
          });
        });
    }
  };

  return {
    handleApproveDocument
  };
};

export default useApproveDocument;
